export function placeholders(count: number): undefined[] {
  return Array.from({ length: count })
}
